import React from "react";
import {InvestorContactIcon, AccountsAndAum, AllocationsIcon, OfficeLocationIcon, RelationshipPathIcon} from '../../shared/Icons/index';
import {SearchOutlined, TrendingUpOutlined} from '@material-ui/icons';

export const BT_DEFAULT_FILTERS = {
    'keyword_search': {
        icon: <SearchOutlined/>,
        title: 'Keyword Search',
        innerRef: 'Keywords',
        filters: [
            {key: 'Keyword Search', name: 'Keyword Search', selected: false}
        ]
    },
    'relationship_path': {
        icon: <RelationshipPathIcon />,
        title: 'Relationship Path',
        innerRef: 'Relationship Path',
        filters: [
            {key: 'My Relationships', name: 'My Relationships', selected: false},
            {key: 'My Team\'s Relationships', name: 'My Team\'s Relationships', selected: false},
            {key: 'Introduction Opportunities', name: 'Introduction Opportunities', selected: false},
            {key: 'Your Alumni Matches', name: 'Your Alumni Matches', selected: false},
            {key: 'My Team\'s Relatability', name: 'My Team\'s Relatability', selected: false},
            {key: 'Relatability Strength', name: 'Relatability Strength', selected: false},
        ]
    },
    'contact_location': {
        icon: <OfficeLocationIcon />,
        title: 'Contact Location',
        innerRef: 'Contact Location',
        filters: [
            {key: 'Mile Radius Search', name: 'Mile Radius Search', selected: false},
            {key: 'Branch Office State', name: 'Branch Office State', selected: false},
            {key: 'Branch Office City', name: 'Branch Office City', selected: false},
            {key: 'Branch Office Zip', name: 'Branch Office Zip', selected: false},
            {key: 'Branch Office Country', name: 'Branch Office Country', selected: false},
            {key: 'Branch Office U.S. Region', name: 'Branch Office U.S. Region', selected: false},
            {key: 'Branch Office County', name: 'Branch Office County', selected: false},
            {key: 'Branch Office Metro Area', name: 'Branch Office Metro Area', selected: false},
        ]
    },
    'contact_info': {
        icon: <InvestorContactIcon/>,
        title: 'Contact Info',
        innerRef: 'Contact',
        filters: [
            {key: 'Firm Name', name: 'Firm Name', selected: false},
            {key: 'Contact Title Contains', name: 'Contact Title Contains', selected: false},
            {key: 'SEC/FINRA Registered', name: 'SEC/FINRA Registered', selected: false},
            {key: 'Responsibilities', name: 'Responsibilities', selected: false},
            {key: 'Email is Known', name: 'Email is Known', selected: false},
            {key: 'Skills & Experience', name: 'Skills & Experience', selected: false},
            {key: 'Gender', name: 'Gender', selected: false},
            {key: 'Age Range', name: 'Age Range', selected: false},
            {key: 'Education', name: 'Education', selected: false},
            {key: 'Investment Committee Member', name: 'Investment Committee Member', selected: false},
            {key: 'C-Suite Executive', name: 'C-Suite Executive', selected: false},
            {key: 'Passions & Interests', name: 'Passions & Interests', selected: false},
            {key: 'Spoken Languages', name: 'Spoken Languages', selected: false},
            {key: 'Employment History', name: 'Employment History', selected: false},
            {key: 'Designations', name: 'Designations', selected: false},
            {key: 'New Hire', name: 'New Hire', selected: false},
            {key: 'Firm Tenure', name: 'Firm Tenure', selected: false},
        ]
    },
    'firm_location': {
        icon: <OfficeLocationIcon />,
        title: 'Firm Location',
        innerRef: 'Firm Location',
        filters: [
            {key: 'Mile Radius Search', name: 'Mile Radius Search', selected: false},
            {key: 'State', name: 'State', selected: false},
            {key: 'City', name: 'City', selected: false},
            {key: 'Zip Code Search', name: 'Zip Code Search', selected: false},
            {key: 'Country', name: 'Country', selected: false},
            {key: 'U.S. Region', name: 'U.S. Region', selected: false},
            {key: 'County', name: 'County', selected: false},
            {key: 'Metro Area', name: 'Metro Area', selected: false},
        ]
    },
    'firm_info': {
        icon: <InvestorContactIcon/>,
        title: 'Firm Info',
        innerRef: 'Firm Info',
        filters: [
            {key: 'Firm Name', name: 'Firm Name', selected: false},
            {key: 'Institution Type', name: 'Institution Type', selected: false},
            {key: 'Charter Type', name: 'Charter Type', selected: false},
            {key: 'RSSD ID', name: 'RSSD ID', selected: false},
            {key: 'FDIC Cert Number', name: 'FDIC Cert Number', selected: false},
            {key: 'OCC Charter Number', name: 'OCC Charter Number', selected: false},
            {key: 'Total Assets', name: 'Total Assets', selected: false},
            {key: 'Year Founded', name: 'Year Founded', selected: false},
            {key: 'Services Provided', name: 'Services Provided', selected: false},
            {key: 'Primary Federal Regulator', name: 'Primary Federal Regulator', selected: false},
            {key: 'State Regulated Only', name: 'State Regulated Only', selected: false},
        ]
    },
    'fiduciary_assets_accounts': {
        icon: <AccountsAndAum />,
        title: 'Fiduciary Assets and Accounts',
        innerRef: 'Fiduciary Assets and Accounts',
        filters: [
            {key: 'Total Fiduciary Assets', name: 'Total Fiduciary Assets', selected: false},
            {key: 'Managed Fiduciary Assets', name: 'Managed Fiduciary Assets', selected: false},
            {key: 'Number of Accounts', name: 'Number of Accounts', selected: false},
            {key: 'Number of Managed Accounts', name: 'Number of Managed Accounts', selected: false},
            {key: 'Average Account Size', name: 'Average Account Size', selected: false},
            {key: 'Average Managed Account Size', name: 'Average Managed Account Size', selected: false},
            {key: 'Personal Trust and Agency', name: 'Personal Trust and Agency', selected: false},
            {key: 'Employee Benefit and Retirement', name: 'Employee Benefit and Retirement', selected: false},
            {key: 'Corporate Trust and Agency', name: 'Corporate Trust and Agency', selected: false},
            {key: 'Investment Management and Investment Advisory', name: 'Investment Management and Advisory', selected: false},
            {key: 'Foundation and Endowment', name: 'Foundation and Endowment', selected: false},
            {key: 'Other Fiduciary', name: 'Other Fiduciary', selected: false},
        ]
    },
    'asset_breakdown': {
        icon: <AllocationsIcon />,
        title: 'Asset Breakdown',
        innerRef: 'Asset Breakdown',
        filters: [
            {key: 'Mutual Funds', name: 'Mutual Funds', selected: false},
            {key: 'Common and Preferred Stocks', name: 'Common and Preferred Stocks', selected: false},
            {key: 'Fixed Income', name: 'Fixed Income', selected: false},
            {key: 'Collective and Common Trust', name: 'Collective and Common Trust', selected: false},
            {key: 'Real Estate', name: 'Real Estate', selected: false},
            {key: 'Alternatives', name: 'Alternatives', selected: false},
            {key: 'Cash and Deposits', name: 'Cash and Deposits', selected: false},
            {key: 'Miscellaneous', name: 'Miscellaneous', selected: false},
            {key: 'Noninterest-Bearing Deposits', name: 'Noninterest-Bearing Deposits', selected: false},
            {key: 'Interest-Bearing Deposits', name: 'Interest-Bearing Deposits', selected: false},
            {key: 'U.S. Treasury and U.S. Government Agency Obligations', name: 'U.S. Treasury and U.S. Government Agency Obligations', selected: false},
            {key: 'State, County, and Municipal Obligations', name: 'State, County, and Municipal Obligations', selected: false},
            {key: 'Money Market Mutual Funds', name: 'Money Market Mutual Funds', selected: false},
            {key: 'Equity Mutual Funds', name: 'Equity Mutual Funds', selected: false},
            {key: 'Other Mutual Funds', name: 'Other Mutual Funds', selected: false},
            {key: 'Common Trust and Collective Investment Funds', name: 'Common Trust and Collective Investment Funds', selected: false},
            {key: 'Other Short-Term Obligations', name: 'Other Short-Term Obligations', selected: false},
            {key: 'Other Notes and Bonds', name: 'Other Notes and Bonds', selected: false},
            {key: 'Unregistered Funds and Private Equity', name: 'Unregistered Funds and Private Equity', selected: false},
            {key: 'Other Common and Preferred Stocks', name: 'Other Common and Preferred Stocks', selected: false},
            {key: 'Real Estate Mortgages', name: 'Real Estate Mortgages', selected: false},
            {key: 'SA Real Estate', name: 'Real Estate', selected: false},
            {key: 'Miscellaneous Assets', name: 'Miscellaneous Assets', selected: false},
        ]
    },
    'favorites_tags': {
        icon: <TrendingUpOutlined/>,
        title: 'Your Favorites, Tags & Custom Properties',
        innerRef: 'Favorites Tags',
        filters: [
            {key: 'Favorites', name: 'Favorites', selected: false},
            {key: 'Tags', name: 'Tags', selected: false},
            {key: 'My Custom Properties', name: 'My Custom Properties', selected: false},
        ]
    },
};
